import { render, staticRenderFns } from "./WalletParentUnconfimDialog.vue?vue&type=template&id=2c2d9063&scoped=true"
import script from "./WalletParentUnconfimDialog.vue?vue&type=script&lang=js"
export * from "./WalletParentUnconfimDialog.vue?vue&type=script&lang=js"
import style0 from "./WalletParentUnconfimDialog.vue?vue&type=style&index=0&id=2c2d9063&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2d9063",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c2d9063')) {
      api.createRecord('2c2d9063', component.options)
    } else {
      api.reload('2c2d9063', component.options)
    }
    module.hot.accept("./WalletParentUnconfimDialog.vue?vue&type=template&id=2c2d9063&scoped=true", function () {
      api.rerender('2c2d9063', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/Wallet/WalletParentUnconfimDialog.vue"
export default component.exports